import { render } from "./genericPopUp.vue?vue&type=template&id=a2b12534&scoped=true"
import script from "./genericPopUp.vue?vue&type=script&lang=js"
export * from "./genericPopUp.vue?vue&type=script&lang=js"

import "./genericPopUp.vue?vue&type=style&index=0&id=a2b12534&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2b12534"]])

export default __exports__